export default {
  zh: {
    zh: '中文',
    en: '英语',
  },
  en: {
    zh: 'Chinese',
    en: 'English',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/language.js